import React from 'react';
import { useState } from 'react';

const AddTask = ({CanclleAdd, addTask}) => {
    const [task, settask] = useState('');

    return(
        <div className="add-task-container">
        <div className="add-task-popup">
            <h4>Create New Task</h4>
            <textarea value={task} onChange={(e) => settask(e.target.value)}></textarea>
            <div className="buttons">
                <button onClick={() => addTask(task)}>Add Task</button>
                <button onClick={() => CanclleAdd(false)}>Cancle</button>
            </div>
        </div>
        </div>
    )
};

export default AddTask;
